// extracted by mini-css-extract-plugin
export default {"heading":"UsersList_heading__f0UHV","deleteLink":"UsersList_deleteLink__ajISk"};